const config = {
    localAuth: {
        //apiServiceUrl: 'https://matchapi.sipanote.com/api/'
        //apiServiceUrl: 'http://192.168.12.140:5000/api/'
        // apiServiceUrl: 'http://127.0.0.1:8888/api/'
        apiServiceUrl: "https://dxlheat6xxapm.cloudfront.net/api/"
    },
    chatServer: {
        url:"wss://chat.sipanote.com/websocket"
    }
}

export default config
